import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Col, FormGroup, Input, Label, Spinner, ModalFooter, ModalBody, Modal,
} from "reactstrap";
import { NavLink as NavLinkRRD, Link, useHistory } from "react-router-dom";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import { Form, Field } from "react-final-form";
import dataProvider from 'dataProvider';
import auth from "authProvider";
import decodeJwt from 'jwt-decode';

const Locations = (props) => {
  const history = useHistory();
  const [edit, setEdit] = useState(false);
  const [flag, setFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOption_update, setSelectedOption_update] = useState(null);
  const [pos, setPos] = useState(false);
  const [childPos, setChildPos] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [sucess, setSucess] = useState(false);
  const [updatesucess, setUpdatesucess] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState({ visible: false, id: null, index: null });
  const [confirmOpenchild, setConfirmOpenchild] = useState({ visible: false, id: null, index: null, item: null });
  const [peropen, setPeropen] = useState(false)
  const [page, setPage] = useState(1);
  const [more, setMore] = useState(true);
  const [reload, setReload] = useState(false);


  const onLogout = () => {
    auth.logout();
    history.push("/")
  }
  useEffect(() => {
    let token = localStorage.getItem('token');
    setSelectedOption(null)
    dataProvider.getList('locations/list', { params: { pagination: { page: page, perPage: 10 }, sort: { order: 'desc', field: 'id' }, filter: {}, token: token } })
      .then(({ data }) => {
        if (data[0].data.length < 10) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        setLocations(data[0].data);
      })
      .catch(error => {
        setLoading(false)
        if (error?.response?.data?.message === 'Invalid Token') {
          setModalOpen(true)
        }
      });
  }, [props, reload]);

  const onSubmit = values => {
    dataProvider.create('locations', { params: { ...values, compound: selectedOption } })
      .then(({ data }) => {
        setSucess(true)
        setTimeout(() => Push(), 2000);
        setLoading(false)
        history.push('/locations');
      })
      .catch(error => {
        setLoading(false)
        if (error?.response?.data?.message === 'Invalid Token') {
          setModalOpen(true)
        }
      });
  };
  const Closeconfirm = () => {
    setConfirmOpen({ visible: false, id: null, index: null });
  };
  const Closeconfirmchild = () => {
    setConfirmOpenchild({ visible: false, id: null, index: null, item: null });
  };

  const removeData = (id, index) => {
    dataProvider.delete('locations', { id: id });
    let locationArr = locations;
    locationArr.splice(index, 1);
    setLocations(locationArr);
    setFlag(!flag)
    setConfirmOpen({ visible: false, id: null, index: null });
  }
  // const removeChild = (id, index) => {
  //   dataProvider.delete('locations', {id:id});
  //   let locationArray = locations;
  //   locationArray.splice(index, 1);
  //   setLocations(locationArray);
  //   setFlag(!flag);
  //   history.push('/locations');
  //   setConfirmOpenchild({ visible: false, id: null, index: null });
  // }
  const removeChild = (id, index, item) => {
    dataProvider.delete('locations', { id: id })
      .then(({ data }) => {
        let locationArray = item.children;
        locationArray.splice(index, 1);
        setLocations(locationArray)
        history.push('./locations')
        setConfirmOpenchild({ visible: false, id: null, index: null, item: null });

      })
      .catch(error => { });

  }
  const onChangeSelection = (e) => {
    setSelectedOption(e);
  };
  const Edit_toggle = (item) => {
    setSelectedOption_update(null);
    setEdit(true);
    setPos(item);
    setChildPos(false);

  };
  const Edit_Children = (item, child) => {
    setSelectedOption_update(child.compound);
    setEdit(true);
    setPos(item);
    setChildPos(child);
  };
  const onSubmit_update = (values, id) => {
    setLoading(true)
    let lId = childPos ? childPos._id : pos._id;
    dataProvider.update('locations', { id: lId, params: { ...values, compound: selectedOption_update } })
      .then(({ data }) => {
        setUpdatesucess(true)
        setTimeout(() => Pushupdate(), 2000);
        setLoading(false)
        history.push('/locations');
      })
      .catch(error => {
        setLoading(false)
        if (error?.response?.data?.message === 'Invalid Token') {
          setModalOpen(true)
        }
      });
  };
  const onChangeSelection_update = (e) => {
    setSelectedOption_update(e);
  }
  const Push = () => {
    setSucess(false)
    window.location.reload();

  }
  const Pushupdate = () => {
    setUpdatesucess(false)
    window.location.reload();

  }
  let token = localStorage.getItem('token');
  let per = localStorage.getItem('permission');
  // const decodedToken = decodeJwt(token);
  // const per = decodedToken.user.permissions;

  const perModal = () => {
    setPeropen(true)
  }
  const permodalClose = () => {
    setPeropen(false)
  }
  const onPagination = (i) => {
    let newPage = page + i;
    if (newPage == 0) {
      return;
    }
    else if (i === 1 && !more) {
      return;
    }
    setPage(newPage);
    setReload(!reload);
  }
  if (!locations) {
    return (
      <>
        <div >
          <td style={{ color: '#12ACF6', position: "fixed", top: "50%", left: "55%", transform: "translate(-50%, -50%)" }} colSpan={11}><Spinner /></td>
        </div>
      </>
    )
  }
  console.log(locations)

  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <h1 className="mb-0" style={{ color: 'white', marginLeft: 10 }}>LOCATIONS / VILLAS</h1>
          </div>
        </Container>
      </div>
      <Container className="mt--7" fluid>
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="7">
            <Card className="shadow" style={{ borderRadius: 10 }}>
              <CardHeader className="border-0" style={{ display: 'flex', color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }} >
                <div style={{ alignContent: 'flex-start', fontWeight: 'bold' }}><h3 style={{ fontWeight: 'bold', color: '' }}>LOCATIONS</h3></div>
                <div style={{ alignContent: 'flex-end' }}>
                  {page > 1 || page !== 1 ? <Button onClick={() => onPagination(-1)} style={{ backgroundColor: 'white', fontSize: '0.75rem', height: '2.5rem', padding: '0px', color: 'rgb(66 54 47)', width: '5rem', margin: '0px', borderColor: 'rgb(144 151 153)' }} >
                    <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="prev" />PREV</Button>
                    : <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', height: '2.5rem', padding: '0px', color: '#77665c', width: '5rem', margin: '0px', borderColor: '#ccc' }} >
                      <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="prev" />PREV</Button>}
                  {more ? <Button onClick={() => onPagination(1)} style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: 'rgb(66 54 47)', width: '5rem', borderColor: 'rgb(144 151 153)' }} > NEXT
                    <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="next" /></Button> :
                    <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: '#77665c', width: '5rem', borderColor: '#ccc' }} > NEXT
                      <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="next" /></Button>}
                </div>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr >
                    <th scope="col" style={{ width: 10 }}></th>
                    <th scope="col">LOCATIONS</th>
                    <th scope="col" style={{ width: 100 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {locations && locations.length > 0 && (
                    locations.map((item, index, child) => (
                      <> {item?.compound === null ?
                        <>
                          <tr>
                            <td>
                              <Button className={collapse === index ? "button_collapse_close" : "button_collapse_open"} onClick={() => setCollapse(collapse === index ? false : index)}></Button>
                            </td>
                            <td>
                              <div style={{ color: '#12ACF6', fontSize: '12px' }}>{item.location}</div>
                            </td>
                            <td style={{ flexDirection: 'row', display: 'flex' }}>
                              {per.includes('location_edit') ? <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0 }} onClick={() => Edit_toggle(item)} ><IcomoonReact iconSet={iconSet} color="#ccc" size={15} icon="edit" /></Button> :
                                <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0 }} ><IcomoonReact iconSet={iconSet} color="#ccc" size={15} icon="edit" /></Button>}
                              {per.includes('location_delete') ? <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} onClick={() => setConfirmOpen({ visible: true, id: item._id, index: index })}><IcomoonReact iconSet={iconSet} color="#ccc" size={18} icon="delete" /></Button> :
                                <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }}  ><IcomoonReact iconSet={iconSet} color="#ccc" size={18} icon="delete" /></Button>}
                            </td>
                          </tr>
                          {item.children && item.children.length > 0 && (
                            item.children.map((child, childindex) => (
                              <>
                                {collapse === index && (
                                  <tr>
                                    <td style={{ border: 'none', paddingBottom: '5px', paddingTop: '5px' }}></td>
                                    <td style={{ border: 'none', paddingBottom: '5px', paddingTop: '5px' }}>
                                      <div style={{ color: '#12ACF6', fontSize: '12px' }}>{child.location}</div>
                                    </td>
                                    <td style={{ paddingBottom: '5px', paddingTop: '5px', flexDirection: 'row', display: 'flex', border: 'none', position: 'absolute', right: 11, marginBottom: 5 }}>
                                      {per.includes('location_edit') ? <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0 }} onClick={() => Edit_Children(item, child)} ><IcomoonReact iconSet={iconSet} color="#ccc" size={15} icon="edit" /></Button> :
                                        <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0 }}  ><IcomoonReact iconSet={iconSet} color="#ccc" size={15} icon="edit" /></Button>}
                                      {per.includes('location_edit') ? <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} onClick={() => setConfirmOpenchild({ visible: true, id: child._id, index: childindex, item: item })}><IcomoonReact iconSet={iconSet} color="#ccc" size={18} icon="delete" /></Button> :
                                        <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} ><IcomoonReact iconSet={iconSet} color="#ccc" size={18} icon="delete" /></Button>}
                                    </td>
                                  </tr>
                                )}
                              </>
                            )))}
                        </>
                        : null}
                      </>
                    ))
                  )}
                </tbody>
              </Table>
              <Modal isOpen={confirmOpen.visible} size="sm">
                <div className="modal-header"></div>
                <ModalBody style={{ color: 'red', padding: 0, paddingLeft: 20 }}>DO YOU WANT DELETE THIS  ?</ModalBody>
                <ModalFooter >
                  <Button onClick={Closeconfirm} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    NO
                  </Button>
                  <Button onClick={() => removeData(confirmOpen.id, confirmOpen.index)} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    YES
                  </Button>
                </ModalFooter>
              </Modal>
              <Modal isOpen={confirmOpenchild.visible} size="sm">
                <div className="modal-header"></div>
                <ModalBody style={{ color: 'red', padding: 0, paddingLeft: 20 }}>DO YOU WANT DELETE THIS  ?</ModalBody>
                <ModalFooter >
                  <Button onClick={Closeconfirmchild} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    NO
                  </Button>
                  <Button onClick={() => removeChild(confirmOpenchild.id, confirmOpenchild.index, confirmOpenchild.item)} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    YES
                  </Button>
                </ModalFooter>
              </Modal>
            </Card>
          </Col>
          {edit ? (
            <Col xl="5">
              <Card className="shadow" style={{ borderRadius: 10 }}>
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 style={{ marginLeft: 12, fontWeight: 'bold' }} className="mb-0">Edit new location</h3>
                    </div>
                  </Row>
                </CardHeader>
                <Form
                  onSubmit={onSubmit_update}
                  render={({ handleSubmit, form, values, submitting, validating, valid }) => (
                    <form
                      onSubmit={async event => {
                        await handleSubmit(event)
                        form.reset()
                      }}
                      style={{ paddingTop: '0px', paddingLeft: 20, paddingRight: 30 }}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col lg="12">
                            <FormGroup>
                              <Label style={{ fontSize: ' 0.9rem', color: '#5d5d4d' }} for="location">Compund Name/villa Name</Label>
                              <Field name="location"
                                initialValue={childPos ? childPos.location ? childPos.location : null : pos ? pos.location ? pos.location : null : null}
                              >
                                {({ input, meta }) => (
                                  <div>
                                    <Input
                                      {...input}
                                      style={{ color: 'black', borderRadius: 10 }}
                                      type="text"
                                      name="location"
                                      placeholder="location"
                                    />
                                  </div>
                                )}
                              </Field>
                            </FormGroup>
                          </Col>
                          <Col lg="12">
                            <FormGroup >
                              <Label style={{ fontSize: ' 0.9rem', color: '#5d5d4d' }} for="compound">Choose Compound</Label>
                              <Field name="compound">
                                {({ input, meta, value }) => (
                                  <div>
                                    <Input type="select" value={selectedOption_update} onChange={(e) => onChangeSelection_update(e.target.value)} name="compound" id="compound" style={{ color: 'black' }}>
                                      <option value="" style={{ color: '#ccc' }} >--Select--</option>
                                      {locations && locations.map((item, index) => {
                                        return (<option value={item._id} >{item.location}</option>)
                                      })}
                                    </Input>
                                  </div>
                                )}
                              </Field>
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                      <Col lg="12">
                        <Button disabled={loading} color={'white'} type="submit" style={{ backgroundColor: '#044057', color: 'white', marginLeft: 10, width: '100%', borderRadius: '10px', padding: 15, border: 0, marginBottom: 10 }} >
                          {loading && (<Spinner as="span" size="sm" aria-hidden="true" style={{ marginRight: 20 }} />)}
                          UPDATE</Button>{' '}
                      </Col>
                    </form>
                  )}
                />
              </Card>
            </Col>
          ) : (

            <Col xl="5">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 style={{ marginLeft: 20, fontWeight: 'bold', color: '#5d5d4d' }} className="mb-0">ADD NEW LOCATION</h3>
                    </div>
                  </Row>
                </CardHeader>
                <Form
                  onSubmit={onSubmit}
                  validate={values => {
                    const errors = {};
                    if (!values.location) {
                      errors.location = "Required";
                    }
                    return errors;
                  }}
                  render={({ handleSubmit, reset, form }) => (
                    <form onSubmit={handleSubmit} style={{ paddingTop: '0px', paddingLeft: 20, paddingRight: 30 }}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col lg="12">
                            <FormGroup>
                              <Label style={{ fontSize: ' 0.9rem', color: '#5d5d4d' }} for="location">Compound Name/villa Name</Label>
                              <Field name="location" >
                                {({ input, meta }) => (
                                  <div>
                                    <Input
                                      {...input}
                                      style={{ color: 'black', borderRadius: 10, padding: 22 }}
                                      type="text"
                                      name="location"
                                      placeholder="Location"
                                    />
                                    {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                  </div>
                                )}
                              </Field>
                            </FormGroup>
                          </Col>
                          <Col lg="12">
                            <FormGroup >
                              <Label style={{ fontSize: ' 0.9rem', color: '#5d5d4d' }} for="compound">Choose Compound</Label>
                              <Field name="compound">
                                {({ input, meta, value }) => (
                                  <div>
                                    <Input type="select" value={selectedOption} onChange={(e) => onChangeSelection(e.target.value)} name="compound" style={{ color: 'black', borderRadius: 10 }}>
                                      <option  >--select--</option>
                                      {locations && locations.map((item, index) => {
                                        return (<option value={item._id}>{item.location}</option>)
                                      })}
                                    </Input>
                                  </div>
                                )}
                              </Field>
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                      {per.includes('location_add') ? <Col lg="12">
                        <Button disabled={loading} color={'white'} type="submit" style={{ backgroundColor: '#044057', color: 'white', marginLeft: 10, width: '100%', borderRadius: '10px', padding: 15, border: 0, marginBottom: 20 }} >
                          {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                          SUBMIT</Button>{' '}
                      </Col> :
                        <Col lg="12">
                          <Button onClick={() => perModal()} color={'white'} style={{ backgroundColor: '#044057', marginLeft: '10px', color: 'white', width: '100%', borderRadius: '10px', padding: 15, border: 0, marginBottom: 20 }} >
                            SUBMIT</Button>{' '}
                        </Col>}
                    </form>
                  )}
                />
              </Card>
            </Col>
          )}
        </Row>
      </Container>
      <Modal isOpen={sucess} size="sm">
        <ModalBody style={{ color: 'green' }}>Created successfully!</ModalBody>
      </Modal>
      <Modal isOpen={updatesucess} size="sm">
        <ModalBody style={{ color: 'green' }}>updated successfully!</ModalBody>
      </Modal>
      <Modal isOpen={modalOpen} size="sm">
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'white' }}>Your session has expired. Please sign in again.</ModalBody>
        <ModalFooter>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white' }} type="button">
            LOGOUT
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={peropen} size="sm">
        <ModalBody style={{ color: 'red' }}>You have no acess to change it..!</ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: 20 }}>
          <Button onClick={() => permodalClose()} style={{ backgroundColor: 'red', color: 'white', border: 0 }}>Ok</Button>
        </div>
      </Modal>
    </>
  );
};

export default Locations;
